import Layout from "components/layout/layout";
import { marked } from "helpers/helpers";
import DataProvider from "hoc/data_provider";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

import "./alumini.css";

const AluminiCoordinators = () => {
    return (
        <DataProvider
            endPoint="/web/aluminis/"
            component={AluminiAssociationComponent}
        />
    );
};

export default AluminiCoordinators;

const AluminiAssociationComponent = ({ data }) => {
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        const res = data.filter((item) => item.type === "coodrinator-details");
        setFilteredData(res);
    }, []);

    return (
        <Layout
            title="Alumni Coordinator Details"
            breadcrumb={[
                {
                    name: "Home",
                    path: "/",
                },
                {
                    name: "Alumni Coordinator Details",
                    path: "/alumini-coordinator-details",
                },
            ]}
        >
            <div className="alumini-data-wrapper">
                {filteredData.map((item, index) => {
                    return (
                        <div key={item._id} className="alumini_item">
                            <p
                                dangerouslySetInnerHTML={marked(
                                    item.description
                                )}
                            ></p>
                        </div>
                    );
                })}
            </div>
        </Layout>
    );
};
